<template>
    <div class="operation_box">
		<div class="operation_item">
			<el-dropdown split-button type="primary"
						 @click="showPaymentPlan"
						 @command="(command) => command()"
			>
				<i class="fa fa-search-plus"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="fa fa-search-plus" :command="showPaymentPlan">
						<span>{{ $t("revolvingPutOption.table.operation.showPaymentPlan") }}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
    </div>
</template>

<script>
export default {
    methods: {
		showPaymentPlan() {
			this.params.showPaymentPlan(this.params.data);
		}
	}
};
</script>